import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { buildSyncFieldsValidationSchema } from '@/features/menu-management/helpers/buildSyncFieldsValidationSchema'
import {
  AutoTranslateButton,
  AutoTranslateFormEffect
} from '@/features/menu-management/helpers/AutoTranslateFormEffect'
import { useSelectedLanguagesQuery } from '../hooks/useSelectedLanguagesQuery'

export const useDishSizeFormConfig = () => {
  const { t } = useTranslation()
  const currentLanguage =
    useTranslation().i18n.language || localStorage.getItem('i18nextLng') || ''
  const { defaultLanguageOption, selectedLanguagesOptions } =
    useSelectedLanguagesQuery(currentLanguage)

  const filteredSelectedLanguagesOptions = selectedLanguagesOptions.filter(
    selectedLanguage => selectedLanguage.value !== defaultLanguageOption.value
  )

  const formConfig = {
    id: `dish-size-form`,
    FormEffects: <AutoTranslateFormEffect />,
    // Rendered by the modal in its action row rather than as a form field:
    // a translation helper belongs beside submit and cancel, not wedged
    // between the form's own inputs.
    footerAction: (
      <AutoTranslateButton
        defaultLanguage={defaultLanguageOption?.value || 'en'}
        allLanguages={selectedLanguagesOptions.map(o => o.value as string)}
        syncFieldNames={['translations']}
      />
    ),
    fields: [
      {
        name: `translations.${defaultLanguageOption?.value}`,
        label: defaultLanguageOption?.label,
        focused: true,
        type: 'text',
        required: true,
        validation: z
          .string({
            required_error: t('AUTHORIZATION.LOGIN.EMAIL.VALIDATION.REQUIRED')
          })
          .trim()
          .min(1, {
            message: t('AUTHORIZATION.LOGIN.EMAIL.VALIDATION.REQUIRED')
          })
      },
      {
        name: 'translations',
        type: 'input-group',
        inputGroupDirection: 'column',
        // One field per enabled language: without its own scroll box the group
        // makes the dialog taller than the viewport.
        scrollable: true,
        inputs: [
          ...filteredSelectedLanguagesOptions.map(language => ({
            name: language.value,
            label: language.label,
            focused: true,
            type: 'text',
            validation: z
              .string({
                required_error: t(
                  'AUTHORIZATION.LOGIN.EMAIL.VALIDATION.REQUIRED'
                )
              })
              .trim()
              .min(1, {
                message: t('AUTHORIZATION.LOGIN.EMAIL.VALIDATION.REQUIRED')
              })
          }))
        ]
      }
    ],
    validationSchema: z.object({
      translations: buildSyncFieldsValidationSchema(selectedLanguagesOptions)
    })
  }
  return formConfig
}
